/**
 * Die echte Umgebung für den Browser-Rekorder. (17.09.2026)
 *
 * Getrennt vom Rekorder selbst, damit dessen Regeln ohne Mikrofon, ohne Netz
 * und ohne Lautsprecher prüfbar bleiben — die Entscheidungen stehen dort,
 * die Anschlüsse hier.
 */
import { playBeep } from "./audio-feedback.js";
import type { BrowserRecorderUmgebung } from "./browser-recorder.js";

/*
 * ⚠️ 18.09.2026 — HIER STAND EIN ZWEITER TON-ERZEUGER, VON MIR.
 *
 * Gestern Abend habe ich `kurzerHinweiston()` gebaut: Oszillator, Huellkurve,
 * AudioContext — vierzig Zeilen. `playBeep()` in audio-feedback.ts tat das
 * alles bereits seit Monaten, samt Aufwecken eines angehaltenen Kontexts und
 * der iOS-Entsperrung, die ein frischer Kontext gar nicht haette.
 *
 * Zwei Erzeuger fuer denselben Zweck sind zwei Gelegenheiten
 * auseinanderzulaufen — genau das Muster, das ich am 17.09. den ganzen Tag
 * bekaempft habe, und das mir am selben Abend selbst unterlaufen ist.
 *
 * Der Ton kommt jetzt von dort, mit derselben Art wie die Sprechtasten-
 * Warnung: „achtung". Wer eine davon aendert, aendert beide.
 */

export function echteUmgebung(
  melde: BrowserRecorderUmgebung["melde"],
): BrowserRecorderUmgebung {
  return {
    holeStrom: () =>
      navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      }),

    /*
     * ⚠️ DIESELBE Schnittstelle wie die native Aufnahme. Ein zweiter Weg zum
     *    Server hiesse zwei Ablagen, zwei Verarbeitungen, zwei Wahrheiten —
     *    und die laufen auseinander. So landet die Browser-Aufnahme in
     *    demselben „Mein Alltag", mit demselben Transkript.
     */
    sendeHaeppchen: async (sitzung, seq, blob) => {
      const form = new FormData();
      form.append("session_id", sitzung);
      form.append("seq", String(seq));
      form.append("audio", blob, `${seq}.webm`);
      const r = await fetch("/api/recorder/chunk", {
        method: "POST",
        credentials: "same-origin",
        body: form,
      });
      if (!r.ok) throw new Error(`chunk ${r.status}`);
    },

    schliesseAb: async (sitzung, beginn, grund) => {
      const r = await fetch("/api/recorder/finish", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sitzung,
          recordedAt: beginn,
          endReason: `browser-${grund}`,
          tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      });
      if (!r.ok) throw new Error(`finish ${r.status}`);
    },

    tonGeben: () => playBeep("achtung"),
    melde,
  };
}
